<template>
  <v-app>
    <div class="wrapper">
      <v-container class="pa-0 content">
        <v-progress-circular
          v-if="refreshing"
          indeterminate
        ></v-progress-circular>
        <div v-else>
          <hcm-intro-card :resource="resource"> </hcm-intro-card>
        </div>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import HCMIntroCard from "../components/HCMIntroCard.vue";

export default {
  components: { "hcm-intro-card": HCMIntroCard },
  data() {
    return {
      resource: null
    };
  },
  created() {
    console.log("home");
    this.refreshData();
  },
  computed: {
    analyticsOn() {
      return this.$store.get("analyticsOn");
    }
  },
  methods: {
    loadResource() {
      let r = this.$store.get(`introItem`);

      this.resource = r;

      this.pageTrack(this.$router.currentRoute.path, "Welcome");
    }
  },
  watch: {
    refreshing: function(val) {
      if (!val) {
        this.loadResource();
      }
    },
    analyticsOn: function(val) {
      if (val) {
        this.pageTrack(this.$router.currentRoute.path, "Welcome");
      }
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  background: linear-gradient(90deg, #a0c2de, #d199a3);
}
.content {
  max-width: 690px;
}
</style>
